import { FC } from 'react';
import { ANIMAL_CONSTANTS } from '../../constants/common';
import './exportReadyBadge.scss';

type ExportReadyBadgeProps = {
  isExportReady: boolean;
};

const ExportReadyBadge: FC<ExportReadyBadgeProps> = ({ isExportReady }) => {
  return (
    <span className={`export-ready-badge export-ready-badge--${isExportReady ? 'ready' : 'not-ready'}`}>
      {isExportReady && <span className="export-ready-badge__dot" aria-hidden="true" />}
      {isExportReady ? ANIMAL_CONSTANTS.EXPORT_READY_YES : ANIMAL_CONSTANTS.EXPORT_READY_NO}
    </span>
  );
};

export default ExportReadyBadge;
